import styled from 'styled-components';
import Menu from '../Menu/Menu';
import { themeColor } from '../theme/colors';
import { smBold } from '../theme/typography';
import FiltersStyles from './Filters.styles';

const OperatorMenu = styled(Menu.Menu).attrs({
  position: 'bottom',
})`` as typeof Menu.Menu;
const OperatorItem = styled(Menu.Item)<{ selected?: boolean }>`
  min-width: 0;
  color: ${({ selected }) =>
    selected ? themeColor('gray') : themeColor('textPrimary')};
`;

const OperatorButton = styled.button<{ disabled?: boolean }>`
  border: none;
  color: ${themeColor('textPrimary')};
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  display: flex;
  justify-content: center;
  align-items: center;
  ${smBold};
  height: 100%;
  border-right: 1px solid ${themeColor('strokePrimary')};
  min-width: 38px;
  background: ${themeColor('buttonBackground')};

  &:hover {
    background: ${({ disabled }) =>
      disabled ? 'initial' : themeColor('buttonBackgroundHover')};
  }
`;

const ValueInput = styled.input<{ readOnly?: boolean }>`
  cursor: ${({ readOnly }) => (readOnly ? 'default' : 'edit')};
  padding-inline: 0;
  color: ${themeColor('textPrimary')};
  &:focus {
    outline: none;
  }
`;

const Unit = styled.span`
  cursor: default;
  white-space: nowrap;
`;

const InputContainer = styled.div`
  display: inline-grid;
  vertical-align: top;
  align-items: center;
  position: relative;

  gap: 2px;
  padding: 0 4px;
  height: 100%;

  ${smBold}
  text-align: right;

  &::after,
  ${ValueInput} {
    width: auto;
    min-width: 1em;
    grid-area: 1 / 1;
    font: inherit;
    margin: 0;
    resize: none;
    background: none;
    appearance: none;
    border: none;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    transition: width 80ms ease-out;
    padding-inline-start: 10px;
  }

  ${Unit} {
    grid-area: 1 / 2;
  }

  &::after {
    content: attr(data-value) ' ';
    visibility: hidden;
    white-space: pre-wrap;
  }
`;

const PresetMenu = styled(Menu.Menu).attrs({
  position: 'bottom-start',
})`` as typeof Menu.Menu;

const PresetItem = styled(Menu.Item)<{ selected?: boolean }>`
  padding-right: 16px;

  &:hover {
    background: ${themeColor('buttonHoverBackground')};
  }
`;

const PresetTrigger = styled.div<{ disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  height: 100%;
  display: flex;
  align-items: center;

  &:hover {
    background: ${themeColor('buttonHoverBackground')};
  }

  /* Make sure the input doesn't show the hover effect */
  &:hover ${ValueInput} {
    background: none;
  }
`;

const Content = styled.div`
  background: none;
  border: none;
  color: ${themeColor('textPrimary')};
  cursor: pointer;
  ${smBold};

  display: flex;
  align-items: center;
  border-left: 1px solid ${themeColor('strokePrimary')};
  padding-left: 0px;
`;

const LabelContainer = styled(FiltersStyles.Label)`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  cursor: default;

  &:has(+ ${Content}) {
    margin-right: 6px;
  }
`;

const Label = styled.div`
  flex: 1;
`;

const Container = styled(FiltersStyles.Container)`
  display: flex;
  align-items: center;

  & ${Label} + ${Content} {
    padding-left: 0;
  }
`;

export default {
  OperatorMenu,
  OperatorItem,
  OperatorButton,
  InputContainer,
  ValueInput,
  PresetMenu,
  PresetItem,
  PresetTrigger,
  Content,
  ClearButton: FiltersStyles.ClearButton,
  Container,
  LabelContainer,
  Label,
  Unit,
};
